import ENV from "../../env";
import ErrorContent from "../ErrorContent/ErrorContent";
import { useAuthTranslation } from "../../services/culture/auth.translations";
import { useCommonTranslation } from "../../services/culture/common.translations";

export const MigrateComponent = () => {
  const { t: tAuth } = useAuthTranslation();
  const { t: tCommon } = useCommonTranslation();
  const clientId = new URLSearchParams(window.location.search).get("clientId");
  const callbackUrl = new URLSearchParams(window.location.search).get("callbackUrl");

  return (
    <ErrorContent
      title={tAuth("migrate.microsoftAuthRequired")}
      message={`${tAuth("migrate.microsoftAuthRequiredDescription")}\n\n${tAuth("migrate.microsoftAuthRequiredPrompt")}`}
      actions={[
        {
          label: tCommon("common.yes"),
          color: "green",
          onClick: () => {
            window.location.replace(`${ENV.API_SERVER}/microsoft/signin?migrating=true&clientId=${clientId}&callbackUrl=${callbackUrl}`);
          },
        },
        {
          label: tCommon("common.no"),
          color: "red",
          onClick: async () => {
            window.location.replace(`${ENV.API_SERVER}/logout`);
          },
        },
      ]}
    />
  );
};
